import React, {createContext, FC, useContext, useRef, useState} from "react";
import {WithChildren} from "../../../../_metronic/helpers";
import {MenuEntry} from "../../application-configuration/core/_models";
import axios from "../../../helpers/axios";
import {LoadingIndicator} from "../../common/components/LoadingIndicator";
import {RequestError} from "../../common/components/RequestError";
import BlockUi from "react-block-ui";
import TopBarProgress from "react-topbar-progress-indicator";
import {FormDataErrorModal} from "../components/FormDataErrorModal";
import { Http } from "../../../helpers/http";

type DynamicFormContextProps = {
    formData?: any
    submitToFormData: (payload: any) => void
    currentMenu: MenuEntry | undefined
    loading: boolean
}

const initDynamicFormContextPropsState = {
    formData: undefined,
    submitToFormData: async (payload: any) => {
    },
    currentMenu: undefined,
    loading: false
}

const DynamicFormContext = createContext<DynamicFormContextProps>(initDynamicFormContextPropsState)

const useDynamicForm = () => {
    return useContext(DynamicFormContext)
}

interface DynamicFormProviderProps extends WithChildren {
    currentMenu: MenuEntry
    initialFormData: any
}

const DynamicFormProvider: FC<DynamicFormProviderProps> = ({children, currentMenu, initialFormData}) => {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<any | null>(null)
    const [formData, setFormData] = useState<undefined | any>(initialFormData)
    const lastPayload = useRef<any | null>(null)

    const submitToFormData = async (payload: any) => {
        lastPayload.current = payload
        setLoading(true)
        setError(null)
        try {
            const {data: responseData, partial}: {data: any, partial?: boolean} = await Http.post('get_form_data', {
                'menu_id': currentMenu.id,
                ...payload,
            })

            setFormData(!partial ? responseData : {...formData, ...responseData})
        } catch (e) {
            console.error(e)
            setError(e)
        } finally {
            setLoading(false)
        }
    }

    if (formData == null && error) {
        return (
            <RequestError onRefresh={() => submitToFormData(lastPayload.current)}/>
        )
    }

    if (formData == null && loading) {
        return (
            <div className='d-flex align-content-center'>
                <LoadingIndicator/> <span className='ps-5 pt-1'>Loading Form...</span>
            </div>
        )
    }

    return (
        <DynamicFormContext.Provider
            value={
                {formData, submitToFormData, currentMenu, loading}
            }
        >
            {loading && <TopBarProgress/>}
            <BlockUi tag='div' blocking={loading}>{children}</BlockUi>
            {error && <FormDataErrorModal onClose={() => setError(null)}>{error.toString()}</FormDataErrorModal>}
        </DynamicFormContext.Provider>
    )
}

export {DynamicFormProvider, useDynamicForm}

